import React from 'react';
import './Sections.scss';

function Section4() {
  return (
    <section className="sections sections-section4">
      <h3 className="sections-sub">4. Turn to the Experts.</h3>
      <p className="sections-copy">
        By definition, repeat homebuyers have been through the home buying process before. Yet even
        with the twin advantages of experience and equity, the vast majority of repeat homebuyers
        (86%) still used a real estate agent to help with the purchase process, according to NAR
        research.
      </p>
      <p className="sections-copy">
        “Our data shows that younger buyers really rely on agents to help them understand every
        aspect of the real estate transaction,” says Lautz. “But the market environment changes all
        the time, so repeat buyers who have not purchased a home for 10 or more years essentially
        are facing a completely different transaction than they did before. In many ways, they are
        in the same position as first-time home buyers in terms of relying on the expertise of an
        agent – especially for buyers who are looking at unfamiliar neighborhoods far away from
        where they have been living.”
      </p>
    </section>
  );
}

export default Section4;
